import React, { Component } from "react";

var configs = require("../../../../../../public/config.json");

export default class PointsDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applied: !!props.pointsAmount,
      pointsAmount: props.pointsAmount || 0
    };
  }

  handleApplyPoints = () => {
    let { pointsAmount } = this.state;
    pointsAmount = parseInt(pointsAmount);
    const { closeDefaultStatus, calculatedTotal } = this.props;
    const pointsValue = pointsAmount * configs.ptsToGbp;

    const amount =
      (parseFloat(calculatedTotal) < pointsValue &&
        parseFloat(calculatedTotal) / configs.ptsToGbp) ||
      pointsAmount;

    const points = {
      pointsAmount: amount
    };
    closeDefaultStatus("useLocalePoints", points);
    this.setState({
      applied: true,
      pointsAmount: amount
    });
  };
  handleSelectAllPoints = () => {
    const { points } = this.props;
    this.setState({ pointsAmount: points });
  };
  hanleChangeUsedPoints = e => {
    e.preventDefault();
    const { points } = this.props;
    this.setState(
      {
        [e.target.id]: event.target.value
      },
      () => {
        if (points < this.state.pointsAmount) {
          this.setState({ pointsAmount: points });
        }
      }
    );
  };
  handleRemoveUsedPoints = () => {
    this.setState({ pointsAmount: 0 }, () => {
      const { pointsAmount } = this.state;
      const { closeDefaultStatus } = this.props;
      const points = {
        pointsAmount
      };

      closeDefaultStatus("useLocalePoints", points);
      this.setState({ applied: false });
    });
  };
  render() {
    const { points, closePointDesktop } = this.props;
    const { applied, pointsAmount } = this.state;
    return (
      <div className="code-form">
        <div className="d-flex justify-content-between">
          <h5>
            You have <span>{points} eCoins!</span>
          </h5>
          <p className="cancel-text cursor-pointer" onClick={closePointDesktop}>
            Cancel <i className="icon icon-close-mini" />
          </p>
        </div>
        {(applied && (
          <div className="applied d-flex align-items-center">
            {/* ikon gelecek */}
            <div className="check sm">
              <input type="radio" checked disabled />
              <span className="checkmark" />
            </div>
            <p>
              <span>{pointsAmount} eCoins</span> applied!
            </p>
            <a href="javascript:void(0)" onClick={this.handleRemoveUsedPoints}>
              (remove)
            </a>
          </div>
        )) || (
          <div className="d-flex align-items-center">
            <div className="manuel-input d-flex align-items-center">
              <input
                value={pointsAmount || ""}
                onChange={this.hanleChangeUsedPoints}
                id="pointsAmount"
                type="number"
                onKeyPress={evt => {
                  if (
                    (evt.which != 8 && evt.which != 0 && evt.which < 48) ||
                    evt.which > 57
                  ) {
                    evt.preventDefault();
                  }
                }}
              />
              <button
                disabled={!pointsAmount}
                className={`btn btn-${(pointsAmount && "blue") || "gray"}`}
                onClick={this.handleApplyPoints}
              >
                Ok
              </button>
            </div>
            <div
              className="d-flex align-items-center use-all "
              onClick={this.handleSelectAllPoints}
            >
              <div className="check sm">
                <input
                  type="radio"
                  id="useAllCheck"
                  checked={pointsAmount === points}
                />
                <span className="checkmark" />
              </div>

              <label className="cursor-pointer" htmlFor="useAllCheck">
                Use all eCoins
              </label>
            </div>
          </div>
        )}
      </div>
    );
  }
}
